// ============================================================
// Pay Rocky - Utility Functions
// ============================================================

export const formatNGN = (amount) => {
  if (amount === null || amount === undefined) return 'N0';
  return 'N' + Math.round(amount).toLocaleString('en-NG');
};

export const formatCrypto = (amount, symbol) => {
  if (amount === null || amount === undefined) return '0';
  const normalizedSymbol = symbol?.toUpperCase();
  const decimals = ['BTC', 'ETH'].includes(normalizedSymbol)
    ? 6
    : ['USDT', 'USDC'].includes(normalizedSymbol)
      ? 2
      : 4;
  return parseFloat(Number(amount).toFixed(decimals)).toString();
};

export const formatUSD = (amount) => {
  if (!amount) return '$0';
  return '$' + Number(amount).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const formatDate = (value) => {
  if (!value) return '-';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return '-';
  return parsed.toLocaleString('en-NG', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const formatDateShort = (value) => {
  if (!value) return '-';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return '-';
  return parsed.toLocaleDateString('en-NG', {
    month: 'short',
    day: 'numeric',
  });
};

export const secondsUntil = (value) => {
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return 0;
  const diff = parsed.getTime() - Date.now();
  return Math.max(0, Math.floor(diff / 1000));
};

export const formatCountdown = (seconds) => {
  const safeSeconds = Math.max(0, Number(seconds) || 0);
  const minutes = Math.floor(safeSeconds / 60).toString().padStart(2, '0');
  const remainingSeconds = (safeSeconds % 60).toString().padStart(2, '0');
  return `${minutes}:${remainingSeconds}`;
};

export const validateWalletAddress = (address, network) => {
  if (!address || address.trim().length === 0) return false;

  switch (network) {
    case 'BTC':
      return /^(1|3)[a-zA-HJ-NP-Z1-9]{25,34}$/.test(address)
        || /^bc1[a-z0-9]{39,59}$/.test(address);
    case 'ERC20':
    case 'BEP20':
    case 'BASE':
      return /^0x[a-fA-F0-9]{40}$/.test(address);
    case 'TRC20':
      return /^T[a-zA-Z0-9]{33}$/.test(address);
    case 'SOL':
      return /^[1-9A-HJ-NP-Za-km-z]{32,44}$/.test(address);
    case 'LTC':
      return /^(L|M)[a-km-zA-HJ-NP-Z1-9]{26,33}$/.test(address)
        || /^ltc1[a-z0-9]{39,59}$/.test(address);
    case 'TON':
      return /^(EQ|UQ)[A-Za-z0-9_-]{46,64}$/.test(address);
    case 'SUI':
      return /^0x[a-fA-F0-9]{64}$/.test(address);
    default:
      return address.length > 10;
  }
};

export const truncateAddress = (address, start = 8, end = 4) => {
  if (!address) return '-';
  if (address.length <= start + end) return address;
  return `${address.slice(0, start)}...${address.slice(-end)}`;
};

export const capitalize = (str) =>
  str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : '';

export const getInitials = (name) => {
  if (!name) return 'U';
  const parts = name.trim().split(' ');
  return parts.length >= 2
    ? (parts[0][0] + parts[1][0]).toUpperCase()
    : parts[0].slice(0, 2).toUpperCase();
};

export const validateNigerianPhone = (phone) =>
  /^(\+234|0)[789][01]\d{8}$/.test(String(phone || '').replace(/\s/g, ''));

export const maskDocumentNumber = (value) => {
  if (!value) return '-';
  if (value.length <= 4) return value;
  return `${'*'.repeat(Math.max(0, value.length - 4))}${value.slice(-4)}`;
};
